import type { PayloadAction } from '@reduxjs/toolkit';

import type { AllowedFeaturesData } from '~/common/model/api/license';

import type { SetStatePayload } from './_reducer.type';
import type { PermissionState } from './_state.type';

/** Permission Reducer. */
export const permissionReducer = {
  /**
   * Permission setState.
   *
   * @param {PermissionState} state State.
   * @param {PayloadAction<SetStatePayload>} action Action.
   */
  permission_setState: (state: PermissionState, { payload }: PayloadAction<SetStatePayload>) => {
    payload.keys.forEach((key) => {
      state.permission[key] = payload.value;
    });
  },

  /**
   * License setState.
   *
   * @param {PermissionState} state State.
   * @param {PayloadAction<SetStatePayload>} action Action.
   */
  license_setState: (state: PermissionState, { payload }: PayloadAction<AllowedFeaturesData>) => {
    state.license = payload;
  },
};
